import useTranslation from "src/hooks/useTranslation";
import { SingleSelection } from "../GeneralSelection";
import { useFilterOptions } from "./hooks/useFilterOptions";
import { SelectChangeEvent } from "../MuiGenerals";

function ChainNameSingleSelection({
  fieldName,
  value,
  onChange,
  onClear,
}: {
  fieldName: string;
  value: string;
  onChange: (e: SelectChangeEvent<string>) => void;
  onClear?: () => void;
}) {
  const { tc } = useTranslation("common");

  const { chainNamesSelectOptions } = useFilterOptions();

  return (
    <SingleSelection
      value={value}
      label={tc("phSelection", { fieldName })}
      onChange={onChange}
      enumData={chainNamesSelectOptions}
      nameFn={(name) => name}
      clearSelect={onClear || (() => {})}
    />
  );
}

export default ChainNameSingleSelection;
